<template>
    <div class="pt-4">
        <v-row no-gutters class="ga-2">
            <v-col cols="12 " sm="6" md="5">
                <v-text-field
                    v-model="formData.name"
                    :label="`${$t('site_name')}*`"
                    :rules="[requiredRule('site_name')]"
                    @keydown.enter.prevent
                />
            </v-col>
            <v-col class="pb-8 pb-sm-0 mt-sm-2">
                <AccessToApiModal v-model="isShowInfoModal">
                    <template v-slot:activator>
                        <v-btn size="small" variant="text" @click="isShowInfoModal = true">
                            {{ $t('get_API_key') }}
                        </v-btn>
                    </template>
                    <template v-slot:apiKey>
                        <div v-if="b2cKey">{{ b2cKey }}</div>
                    </template>
                </AccessToApiModal>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12 " sm="6" md="5">
                <v-text-field v-model="formData.url" label="Url" @keydown.enter.prevent />
                <div v-if="formData.defaultUrl" v-text="formData.defaultUrl" />
            </v-col>
        </v-row>
    </div>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()
    const {b2cId} = defineProps<{
        b2cId?: number
    }>()

    const isShowInfoModal = ref<boolean>(false)
    const b2cKey = ref<string>('')

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        if (b2cId) await loadB2CKey()
    })

    async function loadB2CKey(): Promise<void> {
        try {
            b2cKey.value = (await $api.b2cKey.get(b2cId)).key
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        }
    }
</script>
